import { render, staticRenderFns } from "./LayoutCustom.vue?vue&type=template&id=8e299ade&scoped=true&"
import script from "./LayoutCustom.vue?vue&type=script&lang=js&"
export * from "./LayoutCustom.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCustom.vue?vue&type=style&index=0&id=8e299ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e299ade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
